<div class="page-header">
  <div class="page-title">Histórico de Movimentações</div>
  <p-button
    label="Voltar"
    icon="pi pi-arrow-left"
    severity="secondary"
    [outlined]="true"
    type="button"
    (onClick)="goBack()"
  />
</div>

<app-table
  [lazy]="true"
  [cols]="cols"
  [findPage]="findPage"
  [service]="movementService"
  [addButton]="false"
  [dropdownFilters]="dropdownFilters"
  sortField="createdAt"
  [sortOrder]="-1"
  tableTitle="Movimentações"
  modelName="movimentações"
/>
